"use client";
import dynamic from 'next/dynamic';

import React from "react";
import { useAuth } from "@/contexts/authContext";
import useTokenBalance from "@/hooks/useTokenBalance";
const Button = dynamic(() => import('@/components/ui/Button'));
import Image from "next/image";

const TokenBalance = () => {
  const { walletAddress } = useAuth();
  const { tokenBalance, tokenSymbol} = useTokenBalance(walletAddress);

  return (
    <div style={{ display: "flex", gap: 12 }}>
      <Button className="shadow-sm focus:outline-none !ring-0 !ring-transparent !ring-offset-0 outline-none hover:outline-none btn-dark border-2 border-metaxseed-gray text-white text-xs lg:text-sm gothamMedium rounded-full px-2 py-1 sm:px-3 sm:py-2 flex items-center justify-center">
        <div className="flex items-center font-normal">
          <Image
            src="https://res.cloudinary.com/dot2onqdb/image/upload/v1729067770/xseed_lr_is7mcx.png"
            className="w-6 h-6 mr-2"
            alt="XSEED TOKEN"
            width={24}
            height={24}
          />
          {tokenBalance} {tokenSymbol}
        </div>
      </Button>
    </div>
  );
};

export default TokenBalance;